function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import hoistNonReactStatic from 'hoist-non-react-statics';
var DEFAULT_TRILOGY_CLASS = 'is-tri';
export var withModifiers = function withModifiers(WrappedComponent) {
  var WithModifiers = function WithModifiers(props) {
    var className = props.className,
        children = props.children,
        others = _objectWithoutProperties(props, ["className", "children"]);

    var modifiers = Object.keys(others).filter(function (mod) {
      return mod.match('^(has|force|is)-');
    });
    var classes = classNames(className, modifiers.filter(function (mod) {
      return others[mod];
    }), DEFAULT_TRILOGY_CLASS);
    modifiers.forEach(function (mod) {
      return delete others[mod];
    });

    var filteredProps = _objectSpread({
      children: children
    }, others);

    return React.createElement(WrappedComponent, _extends({}, filteredProps, {
      className: classes
    }));
  };

  WithModifiers.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any // Preserve the initial component name

  };
  WithModifiers.displayName = WrappedComponent.displayName || WrappedComponent.name; // keep pre-existing static methods

  hoistNonReactStatic(WithModifiers, WrappedComponent);
  return WithModifiers;
}; // export function withModifiers (...args) {
//   return (target) => setModifiers(target, ...args)
// }